export const MODULE_PAYMENT_TASK_TYPES = {
  RPL: "RPL_MODULE_PAYMENT",
  Visa: "VISA_MODULE_PAYMENT",
  Insurance: "INSURANCE_MODULE_PAYMENT",
  "Skill Assessment": "SKILL_ASSESSMENT_MODULE_PAYMENT",
};

export const getModulePaymentTaskType = (moduleName) => {
  const key = (moduleName || "").trim();
  const type = MODULE_PAYMENT_TASK_TYPES[key];
  if (!type) {
    throw new Error(`No module payment task type configured for module: ${key || "(empty)"}`);
  }
  return type;
};

export const isModulePaymentTaskType = (taskType) =>
  Boolean(taskType && Object.values(MODULE_PAYMENT_TASK_TYPES).includes(taskType));

export const getModulePaymentTaskTypeLabel = (taskType, moduleName) => {
  const fromModule = (moduleName || "").trim();
  if (fromModule) return `${fromModule} account verification`;
  const entry = Object.entries(MODULE_PAYMENT_TASK_TYPES).find(([, v]) => v === taskType);
  if (entry) return `${entry[0]} account verification`;
  return null;
};
